/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unsaved_Changes_Save_And_LeaveInputs */

const en_unsaved_changes_save_and_leave = /** @type {(inputs: Unsaved_Changes_Save_And_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save and leave`)
};

const nl_unsaved_changes_save_and_leave = /** @type {(inputs: Unsaved_Changes_Save_And_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opslaan en verlaten`)
};

/**
* | output |
* | --- |
* | "Save and leave" |
*
* @param {Unsaved_Changes_Save_And_LeaveInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const unsaved_changes_save_and_leave = /** @type {((inputs?: Unsaved_Changes_Save_And_LeaveInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unsaved_Changes_Save_And_LeaveInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_unsaved_changes_save_and_leave(inputs)
	return en_unsaved_changes_save_and_leave(inputs)
});